export enum WebsiteSliderButtonTypeEnum {
  Primary = 'primary',
  Additional = 'additional'
}
